import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { convertToTimeZone } from 'date-fns-timezone';

const countdownResetHour =
  +process.env.REACT_APP_HOME_COUNTDOWN_RESET_HOUR ?? 22;

const formatTime = (number) => (number < 10 ? `0${number}` : number);

const Strong = ({ children }) => (
  <strong className="font-semibold">{children}</strong>
);

export const GoneCountdown = ({ className, isProductPage }) => {
  const [time, setTime] = useState({});

  const updateCountdown = () => {
    const now = convertToTimeZone(new Date(), { timeZone: 'Europe/London' });
    let hours = countdownResetHour - now.getHours() - 1;

    if (hours < 0) {
      hours += 24;
    }
    const minutes = 59 - now.getUTCMinutes();
    const seconds = 59 - now.getUTCSeconds();

    setTime({ hours, minutes, seconds });
  };

  useEffect(() => {
    const interval = setInterval(updateCountdown, 1000);

    updateCountdown();

    return () => clearInterval(interval);
  }, []);

  return (
    <p
      className={classnames(
        className,
        'font-sans text-lg md:text-2xl lg:text-[2rem] text-qw-gray-300 font-light md:mb-4 leading-6'
      )}
    >
      {isProductPage && "today's designs: "}
      gone <Strong>forever</Strong> in <Strong>{formatTime(time.hours)}</Strong>{' '}
      hours <Strong>{formatTime(time.minutes)}</Strong> minutes{' '}
      <Strong>{formatTime(time.seconds)}</Strong> seconds
    </p>
  );
};
